export const writeProgramHistory = (path) => {
  localStorage.setItem('historyId', path)
  window.scrollTo({ behavior: 'smooth', top: 0 })
  window.location.hash = 'program-activity'
}
